import { get } from 'lodash';

import { FIELD_PATHS } from '@funnels/constants';
import { RelatedParty } from '@funnels/types';

export const hasAccountantCopy = (relatedParties: RelatedParty[], relatedPartyIndex: number) =>
  relatedParties.some((relatedParty, index) => {
    const employmentId = get({ relatedParties: [relatedParty] }, FIELD_PATHS.RELATED_PARTY_EMPLOYMENT_ID(0));
    const title = get({ relatedParties: [relatedParty] }, FIELD_PATHS.RELATED_PARTY_TITLE(0));
    const firstName = get({ relatedParties: [relatedParty] }, FIELD_PATHS.RELATED_PARTY_FIRST_NAME(0));
    const lastName = get({ relatedParties: [relatedParty] }, FIELD_PATHS.RELATED_PARTY_LAST_NAME(0));
    const phone = get({ relatedParties: [relatedParty] }, FIELD_PATHS.RELATED_PARTY_PHONE(0));
    const businessName = get({ relatedParties: [relatedParty] }, FIELD_PATHS.RELATED_PARTY_BUSINESS_NAME(0));
    const address = get({ relatedParties: [relatedParty] }, FIELD_PATHS.RELATED_PARTY_FORMATTED_ADDRESS(0));
    const hasCopyValues = title || firstName || lastName || phone || businessName || address;
    // check if this is a related party for accountant
    return !!employmentId && index !== relatedPartyIndex && !!hasCopyValues;
  });
